import cloneDeep from 'lodash/cloneDeep'
import { ADD_TO_PROGRESS } from '../../actions/game/progression.actions'

const initialState = {
    nextStage: '1-1',
    stages: {
        1: {
            1: 'new',
        },
    },
}

const progressionReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case ADD_TO_PROGRESS: {
            const {
                chapter, section, status, nextStage: newNextStage,
            } = payload
            const { stages, nextStage: oldNextStage } = state
            const updatedStages = cloneDeep(stages)
            updatedStages[chapter][section] = status

            if (newNextStage && newNextStage !== 'ToBeContinued') {
                const [nextChapterString, nextSectionString] = newNextStage.split('-')
                const nextChapter = parseInt(nextChapterString, 10)
                const nextSection = parseInt(nextSectionString, 10)
                updatedStages[nextChapter] = updatedStages[nextChapter] || {}
                updatedStages[nextChapter][nextSection] = 'new'
            }
            const nextStage = newNextStage || oldNextStage

            return {
                nextStage,
                stages: updatedStages,
            }
        }

        default: {
            return state
        }
    }
}

export default progressionReducer
